import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useLocation } from "react-router";

import { getSelectedEntity } from "../services/API/Patients";
import { setLoading } from "@/store/ui/ui";
import {
    setPatientsData,
    setPatientsBirthDay,
} from "@/store/patients/patients";
import { setUserData } from "@/store/users/users";

export default function useSelectedPatient() {
    const dispatch = useDispatch();
    const location = useLocation();
    const id = location.pathname.split("/")[2];
    const ispatientspage = location.pathname.includes("patients");
    const lokalString = ispatientspage ? "patients" : "users";

    useEffect(() => {
        dispatch(setLoading(true));
        async function fetchData() {
            const response = await getSelectedEntity(id, lokalString);
            if (response && response?.data) {
                if (lokalString === "patients") {
                    dispatch(setPatientsData({ ...response.data }));
                    dispatch(setPatientsBirthDay(response.data.dateOfBirth));
                } else if (lokalString === "users") {
                    dispatch(setUserData({ ...response.data }));
                }
                dispatch(setLoading(false));
            } else {
                toast.error(response?.error || "Не вдалося отримати дані");
                dispatch(setLoading(false));
            }
        }
        fetchData();
    }, [dispatch, id, lokalString]);

    return {
        id,
    };
}
